import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCheckCircle, faCircleCheck, faHouse, faList, faTable, faTimesCircle,
} from '@fortawesome/pro-light-svg-icons'

import { Button, Tools } from '@domain-group/suit-theme'

import useCampaign, { generateUrls } from '@hooks/useCampaign'
import useOrderReconciliation from '@hooks/useOrderReconciliation'

import EnabledPermission from '@components/EnabledPermission'

import { getCampaignType } from '@functions/campaign'

interface OrderReconciliationToolsProps {
  allSelected: boolean,
  callbacks: {
    setState: (state: Partial<{
      campaignSelected: boolean,
      editMode: boolean,
      selectedEntityType: string,
      providerSelected: boolean,
      viewMode: string,
  }>) => void,
  },
  checkHasReconciliationItems: boolean,
  editMode: boolean,
  orderReconciliationPayload: ReturnType<typeof useOrderReconciliation>,
  selectedCampaignId: number,
  selectedEntityType: string,
  selectedProviderId: number,
  viewMode: string,
}

const OrderReconciliationTools = (props: OrderReconciliationToolsProps) => {
  const {
    allSelected,
    callbacks: {
      setState,
    },
    checkHasReconciliationItems,
    editMode,
    orderReconciliationPayload,
    selectedCampaignId,
    selectedEntityType,
    selectedProviderId,
    viewMode,
  } = props

  const {
    callbacks: {
      bulkReconcile, deselectAll, selectAllItems,
    },
    hasSelectedEntities,
    selectedEntityIds,
  } = orderReconciliationPayload

  const { campaign } = useCampaign({ id: selectedCampaignId })
  const { campaignEditDetailsUrl } = generateUrls(campaign, { prefixRoute: '' })

  return (
    <Tools>
      {hasSelectedEntities && selectedEntityType && (
        <Button
          buttonStyle="secondaryUtility"
          icon={<FontAwesomeIcon icon={faCircleCheck} />}
          onClick={() => {
            bulkReconcile({
              entityType: selectedEntityType,
              selectedEntityIds,
            })
          }}
          size="medium"
          //@ts-expect-error
          marginBottom="medium"
        >
          Reconcile
        </Button>
      )}

      {checkHasReconciliationItems && viewMode === 'table' && !editMode && selectedEntityType !== '' && (
        <Button
          buttonStyle="secondaryUtility"
          icon={<FontAwesomeIcon icon={allSelected ? faTimesCircle : faCheckCircle} />}
          //@ts-expect-error
          marginBottom="medium"
          onClick={() => (allSelected ? deselectAll() : selectAllItems(selectedEntityType))}
          size="medium"
        >
          {allSelected ? 'Deselect All' : 'Select All'}
        </Button>
      )}

      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={viewMode === 'table' ? faList : faTable} />}
        onClick={() => {
          deselectAll()
          setState({ viewMode: viewMode === 'table' ? 'list' : 'table' })
        }}
        size="medium"
      >
        {viewMode === 'table' ? 'View As List' : 'View As Table'}
      </Button>

      {!selectedProviderId && (
        <EnabledPermission
          campaignType={getCampaignType(campaign)}
          permissionKey="campaign.details.manage"
        >
          <Button
            // @ts-expect-error TS2322
            as="a"
            buttonStyle="secondaryUtility"
            href={campaignEditDetailsUrl}
            marginTop="medium"
            icon={<FontAwesomeIcon icon={faHouse} />}
            size="medium"
          >
            View Campaign
          </Button>
        </EnabledPermission>
      )}
    </Tools>
  )
}

export default OrderReconciliationTools
